import { useTenant } from '../../../../contexts/TenantContext';

/**
 * Cities taking part in the league.
 *
 * Content comes from the tenant's `league_cities` setting so this page is not
 * tied to any one organisation's data.
 */
const LeagueCities = () => {
  const { siteSettings } = useTenant();
  const cities = Array.isArray(siteSettings?.league_cities) ? siteSettings.league_cities : [];

  const totals = cities.reduce(
    (acc, c) => ({
      employees: acc.employees + (Number(c.employees) || 0),
      entries: acc.entries + (Number(c.entries) || 0),
    }),
    { employees: 0, entries: 0 }
  );

  return (
    <section className="tb-page-section">
      <div className="tb-container">
        <div className="tb-page-banner">
          <img
            src={siteSettings?.page_banners?.cities || '/theme/assets/images/banner-3.jpg'}
            alt="Cities"
          />
        </div>

        <div className="tb-page-content">
          <div className="tb-heading-top">
            <h1 className="tb-page-title">Cities</h1>
          </div>

          {cities.length === 0 ? (
            <p>City details will be published shortly.</p>
          ) : (
            <>
              <p style={{ marginBottom: 18 }}>
                The league runs across <strong>{cities.length} cities</strong>, with{' '}
                <strong>{totals.employees.toLocaleString('en-IN')}</strong> registered participants
                between them taking <strong>{totals.entries.toLocaleString('en-IN')}</strong>{' '}
                competition places.
              </p>

              <div style={{ overflowX: 'auto' }}>
                <table className="tb-table" style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <thead>
                    <tr>
                      <th style={cellHead}>City</th>
                      <th style={cellHead}>Programme</th>
                      <th style={{ ...cellHead, textAlign: 'right' }}>Participants</th>
                      <th style={{ ...cellHead, textAlign: 'right' }}>Entries</th>
                      <th style={cellHead}>Coordinator</th>
                    </tr>
                  </thead>
                  <tbody>
                    {cities.map((c) => (
                      <tr key={c.name}>
                        <td style={cell}><strong>{c.name}</strong>{c.note ? ` (${c.note})` : ''}</td>
                        <td style={cell}>{c.sports ? `${c.sports} sports` : '—'}</td>
                        <td style={{ ...cell, textAlign: 'right' }}>
                          {Number(c.employees || 0).toLocaleString('en-IN')}
                        </td>
                        <td style={{ ...cell, textAlign: 'right' }}>
                          {Number(c.entries || 0).toLocaleString('en-IN')}
                        </td>
                        <td style={cell}>{c.coordinator || '—'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          )}
        </div>
      </div>
    </section>
  );
};

const cellHead = {
  textAlign: 'left',
  padding: '10px 12px',
  borderBottom: '2px solid #d8dee6',
  fontSize: 13,
  textTransform: 'uppercase',
  letterSpacing: '0.06em',
  color: '#5c6b7f',
};

const cell = {
  padding: '10px 12px',
  borderBottom: '1px solid #e6ebf1',
  fontSize: 14,
};

export default LeagueCities;
